<template>
  <div>
    <h3 class="text-h4">I want to register as</h3>
    <div class="d-flex mt-2">
      <v-hover v-slot="{ hover }" v-for="item of items" :key="item.value">
        <v-sheet
          @click="$emit('choose', item.value)"
          :elevation="hover ? 8 : 2"
          class="entity ma-4 pa-4"
          :class="{ 'on-hover': hover }"
        >
          <div class="d-flex">
            <div class="icon">
              <img :src="item.icon" />
            </div>
            <div class="ml-3">
              <h5 class="text-h5">{{ item.name }}</h5>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </v-sheet>
      </v-hover>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          value: "organization",
          name: "an Organization",
          icon: require("@/assets/organization.png"),
          description:
            "As an organization you can contribute Whole Slide Images."
        },
        {
          value: "pathologist",
          name: "a Pathologist",
          icon: require("@/assets/doctor.png"),
          description:
            "Get rewarded for annotating Whole Slide Images and access our Slide Repository."
        },
        {
          value: "researcher",
          name: "a Researcher",
          icon: require("@/assets/researcher.webp"),
          description:
            "Collect Whole Slide Images for your dataset and develop your clinical decision support system."
        }
      ]
    };
  },
  methods: {
    onClick(item) {
      console.log(item.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.entity {
  transition: opacity 0.4s ease-in-out;

  .icon img {
    width: 100px;
  }
}

.on-hover {
  cursor: pointer;
}

.entity:not(.on-hover) {
  opacity: 0.6;
}
</style>
